module.exports = __webpack_public_path__ + "img/electric_no_zone_selected.fb623c30.svg";